// extracted by mini-css-extract-plugin
export var addButton = "_de-4";
export var contentBlockImage = "_de-i";
export var contentBlockWidgetPreview = "_de-g";
export var fulfillmentCutoffWidgetPreview = "_de-9";
export var imageBackdrop = "_de-6";
export var imageIcon = "_de-8";
export var lowProfileImageContainer = "_de-b";
export var lowProfileImageIcon = "_de-f";
export var lowProfileImageIconContainer = "_de-e";
export var lowProfileImagePlaceholder = "_de-d";
export var lowProfileProductImage = "_de-c";
export var lowProfileProductUpsellWidgetPreview = "_de-a";
export var productCard = "_de-5";
export var productImage = "_de-7";
export var productReviewsWidgetPreview = "_de-h";
export var progressBar = "_de-1";
export var progressBarFill = "_de-2";
export var progressBarTrack = "_de-3";
export var shippingOptionWidgetPreview = "_de-j";
export var shippingUpsellProgressBar = "_de-k";
export var thresholdUpsellWidgetPreview = "_de-0";